import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addStudent = createAsyncThunk('addStudent', async (data) => {

    try {
        const token = SessionManager.getCookie("user_token")
        const headers = { "Content-Type": "multipart/form-data" }
        if (token) {
            headers.Authorization = token
        }
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + `student_registration`,
            data: data?.values,
            headers
        })
        return res
    } catch (error) {
        return error.response
    }
})
